"use client";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function Loading(props: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setIsLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      {isLoading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <Image
              width={100}
              height={100}
              src="/images/icon.png"
              alt="loader"
              style={{
                animation: "spin 2.5s linear infinite",
              }}
            />
            <style>{`
              @keyframes spin {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            `}</style>
          </div>
        </div>
      ) : (
        props.children
      )}
    </>
  );
}
